import React from "react";
import PageHeader from "components/common/PageHeader";
import EmbeddedMimecastV2App from "./EmbeddedMimecastV2App";
const MimecastV2App = () => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PageHeader, { title: "Mimecast (v2.0 API) input" }, /* @__PURE__ */ React.createElement("span", null, "This input retrieves logs from version 2.0 of the Mimecast API.")), /* @__PURE__ */ React.createElement(EmbeddedMimecastV2App, null));
export default MimecastV2App;
